import { Component, EventEmitter, inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { GridRequestQuery, User, UserItemsResult } from '@api';
import { CellContext, TableColumn } from '@swimlane/ngx-datatable';
import { map } from 'rxjs';
import { TranslationService } from '../../transloco/services/translation.service';
@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    standalone: false,
})
export class GroupUserListComponent {
    private translationService = inject(TranslationService);

    @Input() public groupUsers: UserItemsResult;
    @Output() public selectionDelete = new EventEmitter<User>();
    @Output() public gridRequestEvent = new EventEmitter<GridRequestQuery>();

    @ViewChild('commandsTemplate', { static: true }) private commandsTemplate: TemplateRef<CellContext>;

    public columns$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            const columns: TableColumn[] = [
                { name: this.translationService.translate('defaults.name'), prop: 'displayName', canAutoResize: true },
                { name: this.translationService.translate('entities.email'), prop: 'email', canAutoResize: true },
                { sortable: false, width: 55, maxWidth: 55, resizeable: false, cellTemplate: this.commandsTemplate, canAutoResize: false },
            ];

            return columns;
        })
    );

    public emitDelete(user: User) {
        this.selectionDelete.emit(user);
    }

    public gridRequested(gridRequestQuery: GridRequestQuery) {
        this.gridRequestEvent.emit(gridRequestQuery);
    }
}
